import React, {useState} from 'react';
import cx from 'classnames';
import {useLocation} from 'react-router-dom';

import Footer from '../Footer';

import styles from './styles.module.scss';
import ProjectsIIRSA from "~screens/Dashboard/screens/ProjectsIIRSA";


import Navbar from '~components/Navbar';
import Toolbar from "~components/Toolbar";
import Drawer from "~components/Drawer";
import Login from "~screens/Login";
import usePageTracking from '../../../utils/usePageTracking';

const AppRoutes = () => {
    usePageTracking();

    const {pathname} = useLocation();

    const [state, setState] = useState({
        searchExpanded: false,
        drawerOpen: false
    });

    const openDrawer = () => {
        setState({...state, drawerOpen: true});
    }

    const closeDrawer = () => {
        setState({...state, drawerOpen: false});
    }

    const {drawerOpen} = state;

    const containerClassName = cx({
        [styles.containerDrawerOpen]: drawerOpen,
        [styles.containerDrawerClosed]: !drawerOpen,
        [styles.containedDrawerOpen]: drawerOpen,
        [styles.containedDrawerClosed]: !drawerOpen,
        [styles.projectsConteiner]: false});
    const footerClassName = cx({
        [styles.containedDrawerOpen]: drawerOpen,
        [styles.containedDrawerClosed]: !drawerOpen,
    });

    if (pathname === '/login') {
        return (
            <>
                <Navbar/>
                <Login/>
                <Footer className={footerClassName}/>
            </>
        );
    }

    return (
        <>
            <Navbar/>
            {/* <Toolbar openDrawer={openDrawer} /> */}
            <Drawer open={drawerOpen} closeDrawer={closeDrawer} openDrawer={openDrawer}/>
            <div className={containerClassName}>
                <ProjectsIIRSA/>
            </div>
            <Footer className={footerClassName}/>
        </>
    );
}

export default AppRoutes;
